import React from 'react';
import { Button, Table, TextLink } from 'react-unity';
import PortOpeningRequest from '../../models/entities/PortOpeningRequest';
import { WorkflowState } from '../../models/enums/WorkflowState';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import ProgressBarSmall from './components/ProgressBarSmall';

interface PortOpeningRequestsByPORRowProps {
	request: PortOpeningRequest;
	subOwnerDisplayName?: string;
}

const StyledButton = styled(Button)`
	width: 120px;
	height: 34px;
`;

const PortOpeningRequestsByPORRow = ({ request, subOwnerDisplayName }: PortOpeningRequestsByPORRowProps) => {
	const navigate = useNavigate();

	const linkToTicket = () => {
		const implementationTicket = request.implementationTicket();
		return implementationTicket !== '' ? (
			<TextLink external target="_blank">
				{implementationTicket}&nbsp;
			</TextLink>
		) : (
			'-'
		);
	};

	const handleViewDetails = () => {
		navigate(`/subscriptions/${request.subscriptionRequestId}/portOpeningRequests/${request.id}`);
	};

	return (
		<Table.Body.Row key={request.id}>
			<Table.Body.Cell>{request.id}</Table.Body.Cell>
			<Table.Body.Cell>{request.direction.displayName}</Table.Body.Cell>
			<Table.Body.Cell style={{position: 'relative'}}>
				<ProgressBarSmall workflowState={request.workflowInstance.currentWorkflowInstanceState.workflowState} porScope={request.direction.name}/>
			</Table.Body.Cell>
			<Table.Body.Cell>{linkToTicket()}</Table.Body.Cell>
			<Table.Body.Cell>{request.isAttestation ? 'Yes' : 'No'}</Table.Body.Cell>
			<Table.Body.Cell>{request.workflowInstance.createdBy.displayName}</Table.Body.Cell>
			<Table.Body.Cell>{request.contactUser?.displayName}</Table.Body.Cell>
			<Table.Body.Cell>
				{request.workflowInstance.currentWorkflowInstanceState.workflowState ===
				WorkflowState.PendingSubscriptionOwnerApproval
					? subOwnerDisplayName
					: request.approvingUser?.displayName}
			</Table.Body.Cell>
			<Table.Body.Cell>
				<StyledButton onClick={handleViewDetails} variant="primary">
					See Details
				</StyledButton>
			</Table.Body.Cell>
		</Table.Body.Row>
	);
};

export default PortOpeningRequestsByPORRow;
